
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              About SIERRA ROJA S.R.L.
            </h2>
            <div className="space-y-6 text-gray-600 text-lg leading-relaxed">
              <p>
                <strong className="text-gray-900">SIERRA ROJA S.R.L.</strong> is a leading technology company specializing in developing innovative security applications that protect users' digital privacy and enhance their online experience. Based in Oberá, Argentina, we are committed to delivering world-class VPN solutions that combine cutting-edge technology with user-friendly design.
              </p>
              <p>
                Our flagship VPN application represents years of research and development in cybersecurity, encryption technologies, and network optimization. We understand the growing importance of online privacy in today's digital world, and our mission is to make advanced security accessible to everyone.
              </p>
              <p>
                At SIERRA ROJA, we believe that internet privacy is a fundamental right. Our VPN solution is built on the principles of transparency, security, and performance. We continuously innovate and improve our technology to stay ahead of emerging threats and provide our users with the most reliable protection available.
              </p>
              <p>
                Whether you're browsing from home, working remotely, or traveling abroad, our VPN ensures your data remains private and secure. We're proud to serve users worldwide who trust us to protect their digital lives every day.
              </p>
            </div>

            <div className="mt-10 grid grid-cols-3 gap-6">
              <div className="text-center p-6 bg-blue-50 rounded-xl">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shield-check-line text-white text-2xl"></i>
                </div>
                <div className="text-2xl font-bold text-gray-900 mb-1">100%</div>
                <div className="text-sm text-gray-600">Secure</div>
              </div>
              <div className="text-center p-6 bg-purple-50 rounded-xl">
                <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-global-line text-white text-2xl"></i>
                </div>
                <div className="text-2xl font-bold text-gray-900 mb-1">Global</div>
                <div className="text-sm text-gray-600">Coverage</div>
              </div>
              <div className="text-center p-6 bg-green-50 rounded-xl">
                <div className="w-12 h-12 bg-green-600 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-customer-service-line text-white text-2xl"></i>
                </div>
                <div className="text-2xl font-bold text-gray-900 mb-1">24/7</div>
                <div className="text-sm text-gray-600">Support</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/e606670d802416699b7dfad229386eda.jpg"
                alt="SIERRA ROJA S.R.L. Company"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-blue-900/30 to-transparent"></div>
            </div>
            
            <div className="absolute -bottom-8 -left-8 bg-white p-8 rounded-2xl shadow-xl max-w-sm">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-900 mb-1">Our Location</div>
                  <div className="text-sm text-gray-600">
                    AV ITALIA 574<br />
                    Oberá, N3361EGN<br />
                    Argentina
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
